import React, { useEffect } from 'react';
import Drawer, { DrawerProps } from '@components/drawer/Drawer';
import CancelOrder, { CancelOrderProps } from '@components/drawer/subcomponents/CancelOrder';
import { msgsWParams } from '@app/locales/en';
import useGlobalAlert from '@app/core/GlobalAlertModal';
import { updateChatAttributes } from '@services/chat.service';
import { addressToString } from '@services/helpers';

type Props = DrawerProps & Omit<CancelOrderProps, ''>;

const DrawerCancelOrder: React.FC<Props> = ({
  contract,
  onOrderCancelled,
  onBackToSearch,
  ...props
}) => {
  const { addSuccessToQueue, addWarningToQueue } = useGlobalAlert();

  const onSuccess = (contractId: string) => {
    addSuccessToQueue(msgsWParams.CANCEL_ORDER_SUCCESS(contractId));
    onOrderCancelled(contractId);
  };

  const onFailure = (contractId: string) => {
    addWarningToQueue(msgsWParams.CANCEL_ORDER_FAILED(contractId));
  };

  /** update chat attributes */
  useEffect(() => {
    updateChatAttributes({
      ContractId:
        contract?.detail.id || '',
      PropertyAddress: addressToString(
        contract?.summary?.address?.address1,
        contract?.summary?.address?.address2,
        contract?.summary?.address?.city,
        contract?.summary?.address?.state,
        contract?.summary?.address?.zip,
      )
    });
  }, [contract]);

  return (
    <>
      <Drawer {...props}>
        {props.isActive && (
          <CancelOrder
            heading="Cancel Order"
            contract={contract}
            onOrderCancelled={onSuccess}
            onOrderCancelFailure={onFailure}
            onBackToSearch={onBackToSearch}
          />
        )}
      </Drawer>
    </>
  );
};

export default DrawerCancelOrder;
